import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProofListPage } from './proof-list';

@NgModule({
  declarations: [
    ProofListPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofListPage),
  ],
  exports: [
    ProofListPage
  ]
})
export class ProofListPageModule { }



// WEBPACK FOOTER //
// ./src/pages/proof-list/proof-list.module.ts